export default "__VITE_ASSET__CQah392s__"